// Dashboard pages
import ListaSimulacoes from '@/components/Dashboard/Views/Simulacoes/Lista'
import PastoSimples from '@/components/Dashboard/Views/Simulacoes/Pasto/Simples'
import PastoCompleto from '@/components/Dashboard/Views/Simulacoes/Pasto/Completo'
import ConfinamentoSimples from '@/components/Dashboard/Views/Simulacoes/Confinamento/Simples'
import ConfinamentoCompleto from '@/components/Dashboard/Views/Simulacoes/Confinamento/Completo'

const routes = [
  {
    path: 'simulacoes/listar',
    name: 'listar-simulacoes',
    component: ListaSimulacoes
  },
  {
    path: 'simulacoes/confinamento/avancado/criar',
    name: 'confinamento-avancado-criar',
    component: ConfinamentoCompleto,
    props: { novo: true }
  },
  {
    path: 'simulacoes/confinamento/avancado/ver/:id',
    name: 'confinamento-avancado-ver',
    component: ConfinamentoCompleto,
    props: { novo: false }
  },
  {
    path: 'simulacoes/confinamento/basico/criar',
    name: 'confinamento-basico-criar',
    component: ConfinamentoSimples,
    props: { novo: true }
  },
  {
    path: 'simulacoes/confinamento/basico/ver/:id',
    name: 'confinamento-basico-ver',
    component: ConfinamentoSimples,
    props: { novo: false }
  },
  {
    path: 'simulacoes/pasto/basico/criar',
    name: 'pasto-basico-criar',
    component: PastoSimples,
    props: { novo: true }
  },
  {
    path: 'simulacoes/pasto/basico/ver/:id',
    name: 'pasto-basico-ver',
    component: PastoSimples,
    props: { novo: false }
  },
  {
    path: 'simulacoes/pasto/avancado/criar',
    name: 'pasto-avancado-criar',
    component: PastoCompleto,
    props: { novo: true }
  },
  {
    path: 'simulacoes/pasto/avancado/ver/:id',
    name: 'pasto-avancado-ver',
    component: PastoCompleto,
    props: { novo: false }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/simulacoes.js